function prefersReducedMotion() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function getHeaderOffset() {
  if (typeof document === "undefined") return 96;
  const header = document.querySelector("header");
  if (!header) return 96;
  return header.getBoundingClientRect().bottom + 12;
}

/**
 * Smoothly scroll to an in-page `#hash` target, offset for the sticky header,
 * and update the URL without a jump. Returns false if the target is missing.
 */
export function smoothScrollToHash(hash: string) {
  const id = hash.replace(/^#/, "");
  const el = document.getElementById(id);
  if (!el) return false;

  const top =
    el.getBoundingClientRect().top + window.scrollY - getHeaderOffset() + 1;
  window.scrollTo({
    top,
    behavior: prefersReducedMotion() ? "auto" : "smooth",
  });

  if (window.history.replaceState) {
    window.history.replaceState(null, "", `#${id}`);
  }

  return true;
}

/** True for plain left-clicks without modifier keys (so new-tab clicks still work). */
export function isPlainLeftClick(event: React.MouseEvent) {
  return (
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey &&
    event.button === 0
  );
}
